<template>
	<div :class="'text-message ' + (isMine ? 'my-text' : '')">
		<div v-for="(item, index) in renderDom" :key="index" class="message-body-span">
			<span class="message-span-text" v-if="item.name === 'span'">{{ item.text }}</span>
			<img v-if="item.name === 'img'" class="emoji-icon" :src="item.src" />
		</div>
	</div>
</template>

<script>
import { parseText } from '../../../base/message-facade';

export default {
	data() {
		return {
			renderDom: []
		};
	},

	components: {},
	props: {
		message: {
			type: Object
		},
		isMine: {
			type: Boolean,
			default: true
		}
	},
	watch: {
		message: {
			handler: function(newVal) {
				this.renderDom = parseText(newVal)
				if(this.renderDom.map(t=>{return t.name}).includes("tips")){
					this.$emit("tips",this.renderDom[this.renderDom.length -1])
				}
			},
			immediate: true,
			deep: true
		}
	},

	beforeMount() {
		// 在组件实例进入页面节点树时执行
	},

	destroyed() {
		// 在组件实例被从页面节点树移除时执行
	},

	methods: {}
};
</script>
<style lang="less" scoped>
.text-message {
	max-width: 500px;
	line-height: 1.5;
	padding: 8px 12px;
	background-color: #f3f4f7;
	border-radius: 2px 10px 10px 10px;
  display: flex;
  flex-wrap: wrap;
}

.my-text {
	border-radius: 10px 2px 10px 10px;
	border: 1px solid #fff;
	/* background: rgba(0, 110, 255, 0.10); */
	color: #fff;
	background-color: #D9F1FF;
}

.message-body-span {
	display: flex;
	justify-content: center;
	align-items: center;
	/*justify-content: flex-start;*/
	flex-wrap: wrap;
	outline: none;
	font-size: 14px;
	color: #333333;
	position: relative;
}

.message-body-span-image {
	width: 20px;
	height: 20px;
	margin: 0 4px;
}

.emoji-icon {
	width: 20px;
	height: 20px;
}

</style>
